import { InfoCircleOutlined } from '@ant-design/icons';
import { DateField, TextField } from '@refinedev/antd';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import CompanyContactInfoModal from '@/components/general/CompanyContactInfoModal';
import LinkTextField from '@/components/general/LinkTextField';
import { COMPANY_URLS } from '@/constants/urls';
import Company from '@/model/General/Company';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { PaymentsChoicesString } from '@/model/Logistic/Shipper/ShipperPayment';
import { RESOURCES } from '@/Resources';

interface ShipmentShowDetailProps {
  record?: Shipment;
  ticket?: any;
}

const ShipmentShowDetail = (props: ShipmentShowDetailProps) => {
  const { t } = useTranslation();
  const { record, ticket } = props;

  return (
    <div className="ShipmentShowDataCard">
      <div className="ShipmentShowData">
        <b>{t('Empresa o Técnico que recibirá el paquete')}</b>
        <Flex gap={4}>
          <LinkTextField
            label={record?.company ? `${record?.company?.full_name} (${record?.company?.id})` : '-'}
            to={`${COMPANY_URLS.ADMIN_EMPRESA}/${record?.company?.id}`}
            admin
          />
          {record?.company && (
            <CompanyContactInfoModal
              company={new Company(record?.company)}
              openButton={
                <Button
                  className="ShipmentShowInfoButton"
                  type="text"
                  size={'small'}
                  icon={<InfoCircleOutlined />}
                />
              }
            />
          )}
        </Flex>
      </div>
      <div className="ShipmentShowData">
        <b>{'CUIT'}</b>
        <TextField value={record?.shipment_cuit ? record?.shipment_cuit : '-'} />
      </div>

      <div className="ShipmentShowData">
        <b>{t('Operador logístico')}</b>
        <TextField value={record?.shipper?.name} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Método de pago')}</b>
        <TextField
          value={record?.shipper_payment ? t(PaymentsChoicesString[record?.shipper_payment]) : '-'}
        />
      </div>

      <div className="ShipmentShowData">
        <b>{t('Observaciones')}</b>
        <TextField value={record?.comment ?? '-'} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Fecha de envío estimada')}</b>
        <DateField value={record?.date_estimated} />
      </div>
      {record?.ticket && ticket && (
        <div className="ShipmentShowData">
          <b>{t('Ticket asociado')}</b>
          <LinkTextField
            label={`${ticket?.ticket_title_str} (${ticket?.id})`}
            to={`/tickets/show/${ticket?.id}`}
            local
          />
          <LinkTextField
            label={t('Ver caso completo')}
            to={`/${RESOURCES.CASE_RESOLUTION}/${ticket?.id}`}
            local
          />
        </div>
      )}
    </div>
  );
};

export default ShipmentShowDetail;
